
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/programs/module",
      function () {
        return require("private-next-pages/programs/module/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/programs/module"])
      });
    }
  